module.exports = __webpack_public_path__ + "img/773-584df9.png";